import classnames from 'classnames';

import { ComponentProvider } from './context/ComponentProvider';

import { Comment } from './components/Comment';
import SkeletonLoader from './components/SkeletonLoader';

import type { CommentData } from '../types';
import { postCommentsFeedElement } from './PostCommentsFeed.css';
import type { PostCommentsFeedElementProps } from './PostCommentsFeed.types';

export function PostCommentsFeedElement(props: PostCommentsFeedElementProps) {
  const {
    isLive = false,
    onLike,
    replyingToCommentId,
    onClickReply,
    onClickAction,
    replyNode,
    comments = [],
    canReply,
    avatarUrl,
    isLoggedInAsAdmin,
    isVisitorLoggedIn,
    onCommentChange,
    onClickLogin,
    onClickSubscribe,
    translations,
    commenterId,
    isSubmitting = false,
    showActions = false,
    isLoading = false,
  } = props;

  const renderComments = (list: CommentData[]) => {
    return list.map((comment) => {
      return (
        <Comment comment={comment} key={comment.id}>
          {renderComments(comment.sub_comments)}
        </Comment>
      );
    });
  };

  return (
    <ComponentProvider
      onLike={onLike}
      onCommentChange={onCommentChange}
      canReply={canReply}
      showActions={showActions}
      isLoggedInAsAdmin={isLoggedInAsAdmin}
      isLive={isLive}
      isSubmitting={isSubmitting}
      replyNode={replyNode}
      replyingToCommentId={replyingToCommentId}
      onClickReply={onClickReply}
      onClickAction={onClickAction}
      avatarUrl={avatarUrl}
      isVisitorLoggedIn={isVisitorLoggedIn}
      onClickLogin={onClickLogin}
      onClickSubscribe={onClickSubscribe}
      translations={translations}
      commenterId={commenterId}
    >
      <div
        className={classnames(
          postCommentsFeedElement,
          'w-full flex flex-col gap-y-2',
          !isLive && 'pointer-events-none',
        )}
      >
        {isLoading ? <SkeletonLoader /> : renderComments(comments)}
      </div>
    </ComponentProvider>
  );
}
